module.exports = __webpack_public_path__ + "img/vow_btn2.7c42dba2.png";